import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import logo from '../../../../images/trusteeLogo.png';
import './homepage.css'
import config from '../../../../config/environment'
import axios from 'axios'
import CheckAuth from '../../elements/checkAuth';

export default function AdminHomepage () {
    const [state, setState] = useState({
        login: null,
        password: null,
    });

    const history = useHistory();

    const handleInput = (value, type) => {
        const newState = { ...state };
        newState[type.toLowerCase()] = value;
        setState(newState);
    };

    const loginButtonHandler = async () => {
        if (!state.login || !state.password) { return; }

        await axios.post(config.backendUrl + '/auth/login', state)
        .then(response => {
            localStorage.setItem('jwtToken', response.data.accessToken);
            history.push('/skr/history');
        })
        .catch(error => alert(error.response.data.message));
    };

    return (
        <>
            <CheckAuth />
            <div className="adminLogin">
                <img src={logo} className="adminLogin__logo" alt="logo" />
                <input className="adminLogin__input" placeholder="login" value={ state.login || '' } onChange={event => handleInput(event.target.value, 'LOGIN')} />
                <input className="adminLogin__input" type="password" placeholder="password" value={ state.password || '' } onChange={event => handleInput(event.target.value, 'PASSWORD')} />
                <div className="adminLogin__button_wrapper">
                    <button onClick={loginButtonHandler}>Login</button>
                </div>
            </div>
        </>
    )
}